module.exports = __webpack_public_path__ + "img/whatsapp.f2cbfbb.svg";